
    var riot = require('riot')
    //src: starling/src/tags/loading.html
riot.tag2('loading',
  '<div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div>',
  '',
  'class="spinner spinning"', function(opts) {
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('loading')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/loading.html
// module id = 782
// module chunks = 0